export default __webpack_public_path__ + "static/media/Contract.0e812edf.png";